import React from 'react';
import './LegalPage.css';

const PoliticaPrivacidad = () => (
    <div className="legal-page">
            <h1>Política de Privacidad de Navi</h1>
            <p><strong>Fecha de última actualización:</strong> 21/06/2025</p>

            <h2>1. Responsable del Tratamiento</h2>
            <ul>
                    <li><strong>Nombre comercial:</strong> Navi</li>
                    <li><strong>Titulares legales:</strong>
                            <ul>
                                    <li>Juan Manuel Zambrano Obando (NIE: Z1124167R)</li>
                                    <li>Juan Diego Espinosa Rondón (NIE: Z0667628N)</li>
                            </ul>
                    </li>
                    <li><strong>Dirección:</strong> C/ Echegaray Alcoy (Alicante), España</li>
                    <li><strong>Correo electrónico de contacto:</strong> contacto@navitechlabs.com</li>
                    <li><strong>Dominio web:</strong> <a href="https://www.navitechlabs.com/">https://navitechlabs.com</a></li>
            </ul>

            <h2>2. Finalidad del Tratamiento y Base Jurídica</h2>
            <p>Tratamos los datos personales para:</p>
            <ul>
                    <li>Gestionar consultas realizadas a través del formulario de contacto – Consentimiento expreso</li>
                    <li>Enviar comunicaciones comerciales (si el usuario lo consiente) – Consentimiento expreso</li>
                    <li>Mejorar la web y análisis de navegación (cookies analíticas) – Consentimiento del usuario</li>
                    <li>Prestación de servicios digitales y automatización (si se contratan) – Ejecución de contrato</li>
            </ul>

            <h2>3. Categorías de Datos Tratados</h2>
            <p>Recogemos:</p>
            <ul>
                    <li>Datos identificativos: nombre, apellidos, empresa</li>
                    <li>Datos de contacto: correo electrónico y teléfono</li>
                    <li>Datos de navegación: IP, ubicación aproximada, cookies</li>
                    <li>Datos comerciales (si se contrata algún servicio)</li>
            </ul>
            <p>No tratamos categorías especiales de datos (sensibles).</p>

            <h2>4. Destinatarios de los Datos</h2>
            <p>Los datos podrán ser comunicados a:</p>
            <ul>
                    <li>Google LLC (Google Analytics con cláusulas contractuales tipo)</li>
                    <li>Servicios de hosting y correo electrónico (proveedor europeo)</li>
                    <li>Encargados de tratamiento (CRM, formularios, automatización, etc.)</li>
            </ul>
            <p>No se cederán datos a terceros salvo obligación legal.</p>

            <h2>5. Transferencias Internacionales</h2>
            <p>Puede haber transferencias fuera del EEE, especialmente con Google Analytics, protegidas por cláusulas contractuales tipo conforme al art. 46 RGPD.</p>

            <h2>6. Plazo de Conservación</h2>
            <p>Los datos se conservarán:</p>
            <ul>
                    <li>Mientras dure la relación comercial</li>
                    <li>Hasta que el usuario solicite su supresión</li>
                    <li>Según plazos legales fiscales o contables aplicables</li>
            </ul>

            <h2>7. Derechos del Usuario</h2>
            <p>El usuario puede ejercer los derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad enviando un correo a <a href="mailto:contacto@navitechlabs.com">contacto@navitechlabs.com</a>. También puede presentar una reclamación ante la AEPD.</p>

            <h2>8. Seguridad</h2>
            <p>Navi ha implementado medidas técnicas y organizativas adecuadas para proteger tus datos.</p>

            <h2>9. Modificaciones</h2>
            <p>Nos reservamos el derecho a modificar esta política. Cualquier cambio se publicará en esta misma página.</p>
    </div>
);

export default PoliticaPrivacidad;
